import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Typography,
  Space,
  Table,
  Slider,
  Anchor,
  Divider,
  Breadcrumb,
  Menu,
  Dropdown,
  PageHeader,
  Pagination,
  Steps,
  AutoComplete,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Radio,
  InputNumber,
  Rate,
  Select,
  Switch,
  TimePicker,
  Upload,
  Avatar,
  Badge,
  Carousel,
  Collapse,
  Comment,
  Tooltip,
  Descriptions,
  Image,
  List,
  Popover,
  Statistic,
  Tabs,
  Tag,
  Timeline,
  Alert,
} from 'antd';
import { StatusLabel, Link } from '../components';

import { Line } from '@ant-design/charts';
import { Pie, Scatter } from '@ant-design/plots';

const compConfig = {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Typography,
  Space,
  Table,
  Line,
  Pie,
  Scatter,
  StatusLabel,
  Slider,
  Anchor,
  Divider,
  Breadcrumb,
  Menu,
  Dropdown,
  PageHeader,
  Pagination,
  Steps,
  AutoComplete,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Radio,
  InputNumber,
  Rate,
  Select,
  Switch,
  TimePicker,
  Upload,
  Avatar,
  Badge,
  Carousel,
  Collapse,
  Comment,
  Tooltip,
  Descriptions,
  Image,
  List,
  Popover,
  Statistic,
  Tabs,
  Tag,
  Timeline,
  Alert,
  Link,
};

export default compConfig;
